import axios from "axios"
import { GetUserToken } from "./GlobalMethods"

export const api = axios.create()

api.interceptors.request.use(
  (config) => {
    const token = GetUserToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      return config
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)
